import { QuantifyVisualisationType } from 'generated/graphql';

export function getVisibleDataPointsLimit(
  visualisationType?: QuantifyVisualisationType,
): number {
  switch (visualisationType) {
    case QuantifyVisualisationType.Bar:
    case QuantifyVisualisationType.Trend:
      return 15;
    case QuantifyVisualisationType.Pie:
      return 15;
    default:
      return 10;
  }
}
